import { useEffect, useState } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';
import Select from '../../components/Select';

export default function CpfSubmission() {
  const [runs, setRuns] = useState<any[]>([]);
  const [cpfRefNumbers, setCpfRefNumbers] = useState<string[]>([]);
  const [form, setForm] = useState({ cpfRefNo: '', payrollRunIds: [] as string[], format: 'NORMAL', contributionType: 'END' });
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/payroll/runs').then((res) => setRuns(res.data.runs));
    api.get('/payroll/system-settings').then((res) => setCpfRefNumbers(res.data.settings?.cpf_ref_numbers || []));
  }, []);

  const toggleRun = (id: string) =>
    setForm((f) => ({ ...f, payrollRunIds: f.payrollRunIds.includes(id) ? f.payrollRunIds.filter((r) => r !== id) : [...f.payrollRunIds, id] }));

  const generate = async () => {
    if (!form.cpfRefNo || !form.payrollRunIds.length) {
      setMessage('Select a CPF reference number and at least one payroll run.');
      return;
    }
    try {
      const res = await api.post('/payroll/cpf-submission', form, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `cpf-submission-${form.format}.txt`;
      a.click();
      setMessage('CPF submission file generated.');
    } catch (e: any) {
      setMessage('Failed to generate CPF submission file.');
    }
  };

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">CPF Submission</h1>
      <div className="bg-white rounded-lg shadow p-6 space-y-4">
        <Select
          label="CPF Reference No."
          value={form.cpfRefNo}
          onChange={(e) => setForm({ ...form, cpfRefNo: e.target.value })}
          options={cpfRefNumbers.map((c) => ({ value: c, label: c }))}
        />
        <div>
          <label className="text-sm font-medium text-gray-700">Pay Period(s)</label>
          <div className="border rounded-lg divide-y mt-1 max-h-40 overflow-y-auto">
            {runs.map((r) => (
              <label key={r.id} className="flex items-center gap-2 px-3 py-2 text-sm">
                <input type="checkbox" checked={form.payrollRunIds.includes(r.id)} onChange={() => toggleRun(r.id)} />
                {r.payroll_number} — {new Date(r.payroll_month).toISOString().slice(0, 7)}
              </label>
            ))}
          </div>
        </div>
        <Select
          label="Contribution Mark"
          value={form.contributionType}
          onChange={(e) => setForm({ ...form, contributionType: e.target.value })}
          options={[
            { value: 'END', label: 'END' },
            { value: 'MID', label: 'MID' },
            { value: 'BONUS', label: 'BONUS' },
          ]}
        />
        <Select
          label="Format"
          value={form.format}
          onChange={(e) => setForm({ ...form, format: e.target.value })}
          options={[
            { value: 'NORMAL', label: 'Normal Format (Summary)' },
            { value: 'EZPAY', label: 'CPF EzPay File' },
          ]}
        />
        <Button onClick={generate}>Generate & Download</Button>
        {message && <p className="text-sm text-gray-600">{message}</p>}
      </div>
    </div>
  );
}
